import Badge from '@mui/material/Badge';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers/PickersDay';
import dayjs, { Dayjs } from 'dayjs';
import { useRouter } from 'next/router';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { EventItem } from 'components/EventsCalendar/types';

function CustomDay(
  props: PickersDayProps<Dayjs> & {
    highlightedDays?: number[];
    eventsByDay?: { [key: number]: EventItem[] };
    currentYear: number;
    currentMonth: number;
    isAdmin: boolean;
  }
) {
  const {
    highlightedDays = [],
    eventsByDay = {},
    day,
    outsideCurrentMonth,
    onDaySelect,
    isFirstVisibleCell,
    isLastVisibleCell,
    currentYear,
    currentMonth,
    isAdmin
  } = props;

  const router = useRouter();
  const isSelected =
    !outsideCurrentMonth &&
    highlightedDays.indexOf(day.date()) >= 0 &&
    day.month() === currentMonth &&
    day.year() === currentYear;

  const isToday = day.isSame(dayjs(), 'day');
  const isBefore = day.isBefore(dayjs(), 'day');

  const handleClick = () => {
    const orgId = router?.query?.organizationId;
    const startDate = day.format('YYYY-MM-DD');
    if (isSelected) {
      const events = eventsByDay[day.date()];
      if (events && events.length > 0) {
        // if has only one event go to the event page if not redirect to the event list page
        if (events.length === 1) {
          router.push(`/events/${events[0].id}`);
        } else {
          router.push(`/organizations/${orgId}/events`);
        }
      }
    } else if (!isBefore && isAdmin) {
      router.push(`/events/create?startDate=${startDate}&orgId=${orgId}`);
    }
  };

  const dayClassName = classNames({
    'MuiButtonBase-root grid justify-center justify-items-center': isSelected,
    [styles['current-day']]: isToday
  });

  return isSelected ? (
    <div className={dayClassName}>
      <Badge
        key={props.day.toString()}
        overlap="circular"
        className="event-day"
        badgeContent={
          <>
            {isSelected ? (
              <img src="/img/icons/event-calendar.svg" />
            ) : undefined}
          </>
        }
      >
        <PickersDay
          outsideCurrentMonth={outsideCurrentMonth}
          day={day}
          onClick={handleClick}
          onDaySelect={onDaySelect}
          isFirstVisibleCell={isFirstVisibleCell}
          isLastVisibleCell={isLastVisibleCell}
        />
      </Badge>
    </div>
  ) : (
    <PickersDay
      outsideCurrentMonth={outsideCurrentMonth}
      day={day}
      onClick={handleClick}
      onDaySelect={onDaySelect}
      isFirstVisibleCell={isFirstVisibleCell}
      isLastVisibleCell={isFirstVisibleCell}
      disabled={isBefore || !isAdmin}
      className={classNames({ [styles['current-day']]: isToday })}
    />
  );
}

export default CustomDay;
